// Share links point at the API's /s/promo/:id page rather than the SPA route,
// because only the server can emit Open Graph tags that crawlers read. That
// page redirects humans straight to /promo/:id.
const API_BASE = process.env.REACT_APP_API_URL || '';

export function apiOrigin() {
  try {
    return new URL(API_BASE, window.location.origin).origin;
  } catch {
    return window.location.origin;
  }
}

export function promoAppUrl(promoId) {
  return `${window.location.origin}/promo/${promoId}`;
}

export function promoShareUrl(promoId) {
  return `${apiOrigin()}/s/promo/${promoId}`;
}
